(function() {
  'use strict';

  angular
    .module('traineeWebApp.services')
    .factory('gridFormatters', gridFormatters);

  gridFormatters.$inject = [];

  function gridFormatters() {
    function cModuleAndSeriesFormatter(row, cell, value, item) {
      return '<div class="cModule-list">' + value + '</div>';
    }

    return {
      cModuleAndSeriesFormatter: cModuleAndSeriesFormatter
    }
  }
})();
